import { Delete, PlusOne } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { IResourceComponentsProps, useTranslation } from "@refinedev/core";
import { Create } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import React from "react";
import { useFieldArray } from "react-hook-form";

export const CreditCreate: React.FC<IResourceComponentsProps> = () => {
  const { translate } = useTranslation();

  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    control,
    getValues,
    setValue,
  } = useForm();

  const { fields, append, remove } = useFieldArray({ control, name: "data" });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <Stack direction="column" spacing={5} alignItems="start">
          {(fields || []).map((item, index) => {
            const creditName = `creditsData.${index}.credit.name`;
            const creditCredit = `creditsData.${index}.credit.credit`;
            const creditMarchandise = `creditsData.${index}.credit.marchandise`;
            const creditConsigne = `creditsData.${index}.credit.consigne`;
            const creditTotalCredit = `creditsData.${index}.credit.total_credit`;
            const paymentEspece = `creditsData.${index}.payment.espece`;
            const paymentConsigne = `creditsData.${index}.payment.consigne`;
            const paymentTotalPayee = `creditsData.${index}.payment.total_payee`;
            const creditReste = `creditsData.${index}.reste`;

            const updateTotalCredit = () => {
              const marchandise = getValues(creditMarchandise);
              const consigne = getValues(creditConsigne);
              setValue(creditTotalCredit, marchandise + consigne);
            };

            const updateTotalPayee = () => {
              const espece = getValues(paymentEspece);
              const consigne = getValues(paymentConsigne);
              setValue(paymentTotalPayee, espece + consigne);
            };

            const updateReste = () => {
              const credit = getValues(creditCredit);
              const totalCredit = getValues(creditTotalCredit);
              const totalPayee = getValues(paymentTotalPayee);
              setValue(creditReste, credit + totalCredit - totalPayee);
              console.log({ rest: credit + totalCredit - totalPayee });
            };

            return (
              <Stack
                key={item.id}
                direction="row"
                alignItems="flex-start"
                spacing={1}
                sx={{
                  p: 2,
                }}
              >
                <TextField
                  {...register(creditName, {
                    required: translate("this-field-is-required"),
                  })}
                  variant="outlined"
                  size="small"
                  label="Name"
                />
                <Stack direction="row" alignItems="start" position="relative">
                  <Typography sx={{ position: "absolute", top: -35 }}>
                    Credit
                  </Typography>
                  <TextField
                    {...register(creditCredit, {
                      required: translate("this-field-is-required"),
                      valueAsNumber: true,
                      value: 0,
                      onChange: updateReste,
                    })}
                    variant="outlined"
                    size="small"
                    label="Credit"
                  />
                  <TextField
                    {...register(creditMarchandise, {
                      required: translate("this-field-is-required"),
                      valueAsNumber: true,
                      value: 0,
                      onChange: () => {
                        updateTotalCredit();
                        updateReste();
                      },
                    })}
                    variant="outlined"
                    size="small"
                    label="Marchandise"
                  />
                  <TextField
                    {...register(creditConsigne, {
                      required: translate("this-field-is-required"),
                      valueAsNumber: true,
                      value: 0,
                      onChange: () => {
                        updateTotalCredit();
                        updateReste();
                      },
                    })}
                    variant="outlined"
                    size="small"
                    label="Consigne"
                  />
                  {/* <TextField
                    {...register(creditTotalCredit, { onChange: updateReste })}
                    variant="outlined"
                    size="small"
                    label="Total Credit"
                    value={getValues(creditTotalCredit)}
                    disabled
                  /> */}
                  <Typography
                    sx={{
                      width: "min-content",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      columnGap: "10px",
                      mx: 2,
                    }}
                  >
                    <b>Total Credit</b>
                    <p>{getValues(creditTotalCredit)}</p>
                  </Typography>
                </Stack>
                <br />
                <Stack direction="row" alignItems="start" position="relative">
                  <Typography sx={{ position: "absolute", top: -35 }}>
                    Payment
                  </Typography>
                  <TextField
                    {...register(paymentEspece, {
                      required: translate("this-field-is-required"),
                      valueAsNumber: true,
                      value: 0,
                      onChange: () => {
                        updateTotalPayee();
                        updateReste();
                      },
                    })}
                    variant="outlined"
                    size="small"
                    label="Espece"
                  />
                  <TextField
                    {...register(paymentConsigne, {
                      required: translate("this-field-is-required"),
                      valueAsNumber: true,
                      value: 0,
                      onChange: () => {
                        updateTotalPayee();
                        updateReste();
                      },
                    })}
                    variant="outlined"
                    size="small"
                    label="Consigne"
                  />
                  <Typography
                    sx={{
                      width: "min-content",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      columnGap: "10px",
                      mx: 2,
                    }}
                  >
                    <b>Total payee</b>
                    <p>{getValues(paymentTotalPayee)}</p>
                  </Typography>
                </Stack>
                {/* <TextField
                  {...register(creditReste, {
                    valueAsNumber: true,
                    onChange: updateReste,
                  })}
                  variant="outlined"
                  size="small"
                  label="Reste"
                  onChange={updateReste}
                  value={getValues(creditReste)}
                  disabled
                /> */}
                <Typography
                  sx={{
                    width: "min-content",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    columnGap: "10px",
                    mx: 2,
                  }}
                >
                  <b>Reste</b>
                  <p>{getValues(creditReste)}</p>
                </Typography>
                <IconButton
                  onClick={() => remove(index)}
                  sx={{ backgroundColor: "red" }}
                >
                  <Delete />
                </IconButton>
              </Stack>
            );
          })}
        </Stack>
        <Button
          startIcon={<PlusOne />}
          onClick={() =>
            append({
              credit: {
                name: "",
                credit: 0,
                marchandise: 0,
                consigne: 0,
                total_credit: 0,
              },
              payment: {
                espece: 0,
                consigne: 0,
                total_payee: 0,
              },
              reste: 0,
            })
          }
        >
          Add Credit
        </Button>
      </Box>
    </Create>
  );
};
